import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";


export default function CustomDialog({ open, onClose, title, content, image, sources, action }) {
   
const theme = useTheme();

    return (
         
          <Dialog 
            open={open} 
            onClose={onClose} 
            fullWidth 
            maxWidth="xl" 
            aria-labelledby="custom-dialog-title"
            aria-describedby="custom-dialog-content"
            
            sx={{ '& .MuiDialog-paper': { 
                  bgcolor: theme.palette.mode === "dark"
                    ? theme.palette.background.paper
                    : theme.palette.background.dialog, 
                  borderRadius: '12px', 
                  py:2,
                  
                }, 
              }}
          >

       <DialogTitle

        id="custom-dialog-title"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: theme.palette.mode === "dark" ? theme.palette.background.paper : theme.palette.background.dialog,
          position: 'relative',
          
        }}
      >
        <Typography
          variant="h4"
          component="span" // prevents invalid <h4> inside <h2>
          sx={{
            flex: 1,
            textAlign: 'center',
            color: theme.palette.text.primary,
            fontWeight: 600,
          }}
        >
          {title}
        </Typography>
      
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 16, top: 16, color: theme.palette.text.secondary, }}
        >
      
          <CloseIcon />    
          </IconButton>

        </DialogTitle>
      
       <DialogContent
            id="custom-dialog-content"
            sx={{
              bgcolor: theme.palette.mode === "dark" ? theme.palette.background.paper : theme.palette.background.dialog,
              display: 'flex',
              flexDirection: 'column',
              gap: 2 }}
          >
            {content && <div>{content}</div>}

            {image && <div>{image}</div>}

            {sources && (
              <Typography
                variant="h6"
                sx={{
                  px: 4,
                  fontFamily: 'Inter',
                  color: theme.palette.text.secondary,
                  fontWeight: 400,
                }}
              >
                {sources}
              </Typography>
            )}
        </DialogContent>

        {/*   <DialogActions sx={{ bgcolor: 'background.dialog', px: 3, pb: 3 }}>
                <Grid container justifyContent="flex-end">
                  {action ? action : <ButtonsMain name="BACK" action={onClose} />}
                </Grid>
              </DialogActions>
           */}
              
        </Dialog>
    );
  }